module.exports = __webpack_public_path__ + "img/location-au.5a2ae5fd.svg";